import {createSvgIcon} from '../create-svg-icon';

export const VolumeDownIcon = createSvgIcon(
  <path d="M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02 0-1.77-1.02-3.29-2.5-4.03zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z" />
, 'VolumeDownOutlined');
